import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useLastLocation } from 'react-router-last-location';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { LeftArrowIcon } from '@/assets/images';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import PublicRoutes from '@/constants/routing/PublicRoutes';
import translate from '@/lib/intl/translate';

function BackButton({ children, className, onClick, fallback }) {
  const authToken = useSelector((state) => state.authentication?.authToken);
  const lastLocation = useLastLocation();
  const history = useHistory();
  // Using state here to lock in the path so that routing events for things like
  // entity detail drawers opening or navigation between tabs does not affect
  // the behavior of this button.
  const [location] = React.useState(lastLocation || fallback);
  const path = location
    ? [location.pathname, location.search, location.hash].join('')
    : '';
  const handleClick = (e) => {
    e.preventDefault();
    if (path) {
      if (Object.values(AuthRoutes).includes(location.pathname) && !authToken) {
        history.push(PublicRoutes.LANDING);
      } else {
        history.push(path);
      }
    } else {
      history.goBack();
    }
    onClick(e);
  };

  return (
    <a
      href={path}
      onClick={handleClick}
      className={classNames(className, 'flex items-center text-text-primary')}
    >
      <LeftArrowIcon className="mr-4" />
      {children}
    </a>
  );
}

BackButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  fallback: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string,
    hash: PropTypes.string,
  }),
};

BackButton.defaultProps = {
  children: translate('GO_BACK'),
  className: '',
  onClick: () => {},
  fallback: null,
};

export default BackButton;
